import React from 'react';
import '../../themes/global.scss';
import '../../themes/job_summary.scss';
import '../../themes/payment.scss';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import { useDispatch } from 'react-redux';

import CardForm from '../../commonComponents/CardForm';
import { addPayment } from '../../actions';

export default () => {
  const dispatch = useDispatch();
  const cardFormResult = (card) => {
    dispatch(addPayment({ card }));
  };

  return (
    <div
      style={{
        margin: 20,
      }}
    >
      <h3 className="global_font f-dark" style={{ textAlign: 'left', marginLeft: 50 }}>
        Add Card
      </h3>
      <ElementsConsumer>
        {({ _, elements }) => <CardForm result={cardFormResult} elements={elements} />}
      </ElementsConsumer>
    </div>
  );
};
